export default function TabButton({ theme, activeTab, setActiveTab }: { theme: string[], activeTab: any, setActiveTab: any }) {
  return (
    <ul id="tab-container" className="flex list-none w-fit gap-2">
      {theme.map((tab: string) => (
        <li
          className={`${tab === activeTab
            ? 'text-primary underline border-b-2 border-primary' : 'text-secondary'} text-sm flex-1 p-2 text-center text-nowrap `}
          key={tab}
        >
          <button
            role="tab"
            aria-selected={tab === activeTab}
            onClick={() => setActiveTab(tab)}
            type="button"
            id={tab}
            className="hover:cursor-pointer"
          >
            {tab}
          </button>
        </li>
      ))}
    </ul>
  );
}
